import {Action} from "@ngrx/store";

export const LOAD_USER_PAYMENTS: string = '[user payments] Load User Payments';
export const LOAD_USER_PAYMENTS_SUCCESS: string = '[user payments] Load User Payments Success';
export const LOAD_USER_PAYMENTS_FAIL: string = '[user payments] Load User Payments Fail';
export const RESET_USER_PAYMENTS: string = '[user payments] Reset User Payments';



export class LoadUserPayments implements Action {

  readonly type: string = LOAD_USER_PAYMENTS;

}

export class LoadUserPaymentsSuccess implements Action {

  readonly type: string = LOAD_USER_PAYMENTS_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserPaymentsFail implements Action {

  readonly type: string = LOAD_USER_PAYMENTS_FAIL;
  constructor(public payload: string) {}

}
export class ResetUserPayments implements Action {

  readonly type: string = RESET_USER_PAYMENTS;

}

export type UserPaymentsAction = LoadUserPayments | LoadUserPaymentsSuccess | LoadUserPaymentsFail;
